var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.352 16.289"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 640"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 639",
    fill: "#bcbec0"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 524",
    d: "M27.352 8.415c-.514.663-.99 1.364-1.546 1.99a18.375 18.375 0 0 1-5.479 4.275 14.6 14.6 0 0 1-5.153 1.53 15.039 15.039 0 0 1-11.049-3.4 21.418 21.418 0 0 1-3.88-3.988 1.066 1.066 0 0 1 0-1.359 19.829 19.829 0 0 1 6.817-5.865 14.559 14.559 0 0 1 5.1-1.52 15.035 15.035 0 0 1 11.013 3.35 21.335 21.335 0 0 1 3.941 4.041 3.086 3.086 0 0 1 .235.407l.001.539Zm-7.941-.262a5.735 5.735 0 1 0-5.891 5.736 5.756 5.756 0 0 0 5.891-5.736Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 525",
    d: "M16.779 8.137a3.1 3.1 0 1 1-3.05-3.087 3.07 3.07 0 0 1 3.05 3.087Z"
  })))));
};
export default SvgEye;